import { LocalizedText } from '@common/models';

export class UcType
{

    constructor (public useCaseTypeId: number, public useCaseType: LocalizedText)
    {
    }
}
